import { AppConfig } from './types';

const defaultConfig: AppConfig = {
  company: {
    name: 'DemoCompany',
    logo: '/logo512.png',
    slogan: 'Przykładowe rozwiązania dla każdego biznesu',
    about: {
      shortInfo: `Jesteśmy <span className="font-semibold">przykładową firmą</span>{' '}
          z wieloletnim doświadczeniem, która stawia na jakość, niezawodność i
          profesjonalną obsługę. Nasz katalog obejmuje szeroki asortyment
          produktów - od produktów A, przez produkty B, po produkty C.`,
    },
    founded: '2013',
  },
  contact: {
    email: 'kontakt@demoapp.pl',
    phone: '+48 123 456 789',
    address: {
      street: 'ul. Przykładowa 1',
      postal: '00-000',
      city: 'Warszawa',
      region: 'mazowieckie',
      country: 'Polska',
    },
  },
  theme: {
    fontFamily: 'Inter, system-ui, sans-serif',
    colors: {
      primary: '#3B82F6',
      secondary: '#10B981',
      accent: '#F59E0B',
      background: '#F9FAFB',
      text: '#1F2937',
    },
    mainColor: 'blue',
  },
  social: {
    // facebook: 'https://facebook.com/demoapp',
    // instagram: 'https://instagram.com/demoapp',
    // youtube: 'https://youtube.com/demoapp',
    // twitter: 'https://twitter.com/demoapp',
    // google: 'https://maps.app.goo.gl/example',
  },
  legal: {
    privacyPolicy: '/privacy-policy',
    termsOfService: '/terms-of-service',
  },
  features: {
    enableReviews: true,
    enableWishlist: true,
    enableComparisons: true,
  },
  ui: {
    home: {
      showNewsletterForm: true,
    },
    navbar: {
      showCategoriesOnHomepage: false,
      userMenuOptions: [
        { label: 'Moje konto', path: '/profil' },
        { label: 'Zamówienia', path: '/profil/zamówienia' },
      ],
      mobileMenuOptions: [
        { label: 'Strona główna', path: '/' },
        { label: 'Kontakt', path: '/kontakt' },
        { label: 'O nas', path: '/o-nas' },
      ],
    },
    footer: {
      showSocialIcons: true,
      showQuickLinks: true,
      quickLinks: [
        { label: 'Strona główna', path: '/' },
        { label: 'Produkty', path: '/szukaj' },
        { label: 'O nas', path: '/o-nas' },
        { label: 'Kontakt', path: '/kontakt' },
      ],
    },
  },
  banners: {
    home: [],
  },
  meta: {
    keywords: [
      'demoapp',
      'e-commerce',
      'zakupy online',
      'sklep internetowy',
      'produkty',
      'usługi',
    ],
    description:
      'DemoApp to innowacyjna platforma e-commerce, która łączy najlepsze produkty i usługi w jednym miejscu. Oferujemy szeroki asortyment, konkurencyjne ceny i wyjątkową obsługę klienta.',
  },
};

export default defaultConfig;
